module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06introduction"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("INTRODUCTION:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pnc"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Why a Lunch-Box Book?")]), _vm._v(" 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 1:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Brown Bag Basics,")]), _vm._v(" 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01#ch1-sec1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Know Good Nutrition, 10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01#ch1-sec2"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Keep Food Cool, 16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01#ch1-sec3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Give Lunch a Makeover, 17")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01#ch1-sec4"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("About Ingredients, 18")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01#ch1-sec5"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("About Recipes and Portions, 19")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 2:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Getting the Job Done,")]), _vm._v(" 20")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#ch2-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Fill Your Arsenal, 22")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#ch2-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Plan Ahead, 23")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#ch2-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Troubleshooting, 25")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#ch2-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Six Steps to a Superb School Lunch, 26")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08chapter02#ch2-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-pb"
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Mains,")]), _vm._v(" 27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 3:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Stellar Sandwiches,")]), _vm._v(" 28")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Hippie-Dippie Bagel Sandwich, 31")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Smoked Salmon Tea Sandwich, 32")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Anything Goes Salad Sandwich, 33")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Italian Picnic Sandwich, 34")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Turkey and Veggie Dagwood, 36")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Turkey and Hummus Cuties, 37")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Waffle Iron Grilled Cheese, 38")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chickpea Panini, 40")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Deconstructed Caprese, 42")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 4:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Salads Kids Will Love,")]), _vm._v(" 46")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#ch4-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Jar of Everyday Vinaigrette, 49")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#ch4-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Kiddie Cobb Salad, 50")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#ch4-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Takeaway Taco Salad, 52")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#ch4-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Fattoush Salad, 53")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#ch4-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Kid-Pleaser Chicken Caesar, 54")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#ch4-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Where’s Waldorf? 55")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10chapter04#ch4-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Asian Lunch-Box Slaw, 56")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 5:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Pinwheels, Pizzas, Wraps, and Roll-Ups,")]), _vm._v(" 58")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05#ch5-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("The Perfect Date, 60")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05#ch5-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Peanut Butter Pinwheels, 62")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05#ch5-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("BLT Roll-Ups, 64")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05#ch5-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Pesto Pita Pizza, 65")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05#ch5-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Prosciutto and Arugula Lavash Pizza, 66")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11chapter05#ch5-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Sweetie Pie Quesadilla, 68")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 6:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Leftovers Made Over,")]), _vm._v(" 70")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Teriyaki Fried Rice, 72")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("“Take Two” Tabbouleh, 74")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Curried Quinoa with Tangerines and Dried Cranberries, 75")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Love Salad, 76")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("“Me So” Happy Noodle Soup, 77")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Shortcut Chicken Noodle Soup, 78")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Creamy Black Bean Soup, 79")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Easy Cheesy Thermos Beans, 80")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Oodles of Sesame Noodles, 82")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Tuna Pasta Classic, 84")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chinese Tacos, 85")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("BBQ on a Bun, 86")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6-sec13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "font-pb"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Sides,")]), _vm._v(" 89")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 7:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Fruit and Veggie Sides,")]), _vm._v(" 90")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("I Heart Watermelon, 92")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Honey-Lime Melon, 93")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Very Berry Skewers, 94")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Teensy Tropical Salad, 95")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Winter Jewel Box Salad, 96")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Juice Box Applesauce, 98")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Really Ranch Dip with Veggies in the Raw, 100")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("My Thai Peanut Dip with Garden-Fresh Faves, 102")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Guacamole and Crunchy Crudités, 103")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7-sec10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Hummus with a Twist and Veggies to Dip, 104")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 8:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Crunchy Extras,")]), _vm._v(" 108")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08#ch8-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Coconut Granola Bark, 110")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08#ch8-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Pumped-Up Party Mix, 112")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08#ch8-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Skinny Mini Cheese Straws, 113")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08#ch8-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cinnamon Wonton Crisps, 114")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08#ch8-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("“Betcha Can’t Eat Just One” Parmesan Kale Chips, 116")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter08#ch8-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("DIY Microwave Popcorn, 118")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 9:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Goodies,")]), _vm._v(" 120")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Cocoa-Dusted Almonds, 122")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Rosie’s Energy Balls, 123")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Sour Cherry Oatmeal Bars, 124")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Chocolate Chip–Pretzel Cookies, 126")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Petite Pumpkin Gingerbread Cupcakes, 127")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Tender Cranberry Streusel Muffins, 130")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Everybody Loves Chocolate Pudding, 132")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-pb"
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("After School,")]), _vm._v(" 135")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-small"
  }, [_c('strong', [_vm._v("CHAPTER 10:")])]), _vm._v(" "), _c('span', {
    staticClass: "font-pncr"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Tide-Me-Overs,")]), _vm._v(" 136")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("“Perfect Every Time” Hard-Boiled Eggs, 138")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("The Comfort of Cottage Cheese and Crackers, 140")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Italian Quesadilla, 141")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Crispy Applewiches, 142")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Out-of-the-Box Peanut Butter Granola Bars, 144")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Dreamy Mango-Orange Pops, 146")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Creamy Banana Shake, 147")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("Raspberry Sneak, 148")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17supplies",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("MOM-APPROVED LUNCH-BOX SUPPLIES,")]), _vm._v(" 150")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18resources",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("RESOURCES,")]), _vm._v(" 151")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("ACKNOWLEDGMENTS,")]), _vm._v(" 152")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("INDEX,")]), _vm._v(" 153")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21table",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("TABLE OF EQUIVALENTS,")]), _vm._v(" 156")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa2c9a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05toc.vue
// module id = 69
// module chunks = 0